export default __webpack_public_path__ + "static/resources-6edd5c9821e11b1fc3f0e75b3dcfefa6.png";